import {
  Box,
  Button,
  IconButton,
  InputLabel,
  OutlinedInput,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import styled from "styled-components";
import { StyledMenuItem } from "../../globalStyle";

export const SettingsSectionWrapper1 = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border1};
  border-radius: 10px;
  padding: 2%;
  background: white;
  position: relative;
`;

export const SettingsSectionWrapper2 = styled.div`
  width: 70%;
  margin: auto;
`;

export const SettingsHeaderText = styled(Typography)`
  && {
    font-weight: 600;
    font-size: 1.375rem;
    color: ${({ theme }) => theme.colors.black2};
  }
`;

export const LogoutButton = styled(Button)`
  && {
    background-color: #fff0f2;
    color: ${({ theme }) => theme.colors.red200};
    text-transform: capitalize;
    border-radius: 50px;
    position: absolute;
    top: 1.875rem;
    right: 16.188rem;
    padding: 0.625rem 1.25rem;
    font-size: 1rem;
    font-weight: 500;
    border: 1px solid #ffe3e7;
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  && {
    color: ${({ theme }) => theme.colors.black2} !important;
    font-size: 1.125rem;
    font-weight: 400;
  }
`;

export const StyledOutlinedInput = styled(OutlinedInput)<{
  nonEditable?: boolean;
}>`
  && {
    color: ${({ theme }) => theme.colors.black2};
    .MuiInputBase-input {
      padding: 1.031rem 0.875rem;
      background: ${({ nonEditable }) => (nonEditable ? "#d3d3d3" : "")};
      cursor: ${({ nonEditable }) => (nonEditable ? "default" : "")};
    }
    .MuiOutlinedInput-notchedOutline,
    &:hover .MuiOutlinedInput-notchedOutline,
    &:focus-within .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.colors.border1};
    }
    &.Mui-error {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${({ theme }) => theme.colors.brandRed};
      }
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-background-clip: text;
      transition: background-color 5000s ease-in-out 0s;
    }
  }
`;

export const ResetPasswordButton = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.link};
    padding: 0;
    background: none !important;
    text-transform: capitalize;
    text-decoration: underline;
    font-weight: 600;
  }
`;

export const CountryCodeSelect = styled(Select)`
  && {
    color: ${({ theme }) => theme.colors.black2};

    .MuiOutlinedInput-notchedOutline,
    &:hover .MuiOutlinedInput-notchedOutline,
    &:focus-within .MuiOutlinedInput-notchedOutline {
      border-right: none !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0;
      border-color: ${({ theme }) => theme.colors.border1};
    }
    .MuiSelect-icon {
      margin-top: 0.25rem;
    }
  }
`;

export const CountryCodeMenuItem = styled(StyledMenuItem)`
  && {
    margin-inline: 0;
  }
`;

export const ProfileUploadButton = styled(IconButton)`
  && {
    background: ${({ theme }) => theme.colors.backgroundPrimary} !important;
    border-radius: 50%;
    padding: 0.5rem;
  }
`;

export const SquareContainer = styled("div")({
  width: "10.625rem",
  height: "10.625rem",
  border: "1px solid #ccc",
  position: "relative",
});

export const LogoUploadButton = styled("button")({
  background: "none",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
});

export const LogoUploadButtonAfter = styled("button")({
  background: "none",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",

  "& svg": {
    width: "16px",
    height: "16px",
    position: "absolute",
    right: "-15px",
    bottom: "-15px",
    background: "linear-gradient(135deg, #1c75bc, #00aeef)!important",
    padding: "10px",
    borderRadius: "20px",

    "& path": {
      fill: "#fff",
    },
  },
});

export const UploadedImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

export const SeatContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 30px;
`;

export const SeatCountBox = styled(Box)`
  background-color: #d7f0fc;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 500;
  min-width: 32px;
  text-align: center;
`;

export const SeatStyledButton = styled(Button)`
  && {
    border: 1px solid #2196f3;
    color: #2196f3;
    border-radius: 24px;
    text-transform: none !important;
    padding: 6px 16px;
    font-weight: 500;
    min-width: fit-content !important;

    &:hover {
      background-color: rgba(33, 150, 243, 0.08);
    }
  }
`;

export const InviteSectionMemberCard = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f1f1f1;
  background-color: #ffffff !important;
`;

export const InviteSectionInfoBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 80%;
`;

export const InviteSectionNameEmailStack = styled(Stack)`
  gap: 0.25rem;
  min-width: ;
`;

export const InviteSectionStatusBadge = styled(Box)<{
  bg: string;
  color: string;
}>`
  padding: 0.375rem 1rem;
  border-radius: 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  min-width: fit-content;
  background-color: ${(props) => props.bg};
  color: ${(props) => props.color};
`;

export const SeatStatusBadge = styled(Box)<{
  isFreeSeat?: boolean;
}>`
  padding: 0.375rem 1rem;
  border-radius: 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  min-width: fit-content;
  background-color: ${({ isFreeSeat }) =>
    !isFreeSeat ? "#EB001B" : "#1AA86E"} !important;
  color: #ffffff;
`;

export const InviteSectionToggleButton = styled(Box)`
  display: flex;
  border-radius: 1.25rem;
  overflow: hidden;
  height: 2.25rem;
  background: #e3e3e3 !important;
  border-radius: 20px !important;
`;

export const InviteSectionToggleOption = styled(Button)<{
  active?: boolean;
  red?: boolean;
}>`
  width: 100% !important;
  text-transform: none !important;
  font-weight: 500;
  font-size: 0.875rem;
  padding: 0 1.25rem;
  background-color: ${({ active, red }) =>
    active ? (red ? "#EB001B" : "#1AA86E") : "#E0E0E0"} !important;
  color: ${({ active }) => (active ? "#fff" : "#414042")} !important;
  border-radius: 0;
  min-width: fit-content !important;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  cursor: ${({ active }) => (active ? "default" : "pointer")} !important;
  user-select: ${({ active }) => (active ? "none" : "auto")} !important;
`;

export const InviteSectionCancelRequestBtn = styled(Button)`
  text-transform: none !important;
  font-weight: 500;
  color: #ffffff !important;
  min-width: auto;
  background-color: #fff0f2 !important;
  color: ${({ theme }) => theme.colors.red200} !important;
  border-radius: 50px !important;
  padding: 0.625rem 1.25rem;
  font-size: 1rem;
  border: 1px solid #ffe3e7 !important;
`;
